<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-broadcast me-2"></i>
          Assign Drone to {{ organizationName }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          {{ errorMessage }}
          <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
        </div>

        <!-- Search Box -->
        <div class="mb-3">
          <label for="droneSearch" class="form-label">Search Available Drones</label>
          <input
            type="text"
            class="form-control"
            id="droneSearch"
            placeholder="Search by serial number, N-Number, or model..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            [disabled]="loading"
          />
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mt-2 text-muted">Loading available drones...</div>
        </div>

        <!-- Drones List -->
        <div *ngIf="!loading" class="drones-list overflow-y-auto mb-3">
          <!-- Summary counts -->
          <div *ngIf="filteredDrones.length > 0" class="d-flex gap-3 mb-2 small">
            <span class="text-success">
              <i class="bi bi-check-circle me-1"></i>
              {{ assignableCount }} assignable
            </span>
            <span *ngIf="unassignableCount > 0" class="text-muted">
              <i class="bi bi-exclamation-circle me-1"></i>
              {{ unassignableCount }} missing N-Number
            </span>
          </div>

          <div *ngIf="filteredDrones.length === 0" class="text-center py-4 text-muted">
            <i class="bi bi-inbox fs-1 d-block mb-2"></i>
            <p *ngIf="searchQuery">No drones found matching your search</p>
            <p *ngIf="!searchQuery">No available drones to assign</p>
          </div>

          <div *ngIf="filteredDrones.length > 0" class="list-group">
            <div
              class="list-group-item"
              *ngFor="let drone of filteredDrones"
              [class.list-group-item-action]="canAssignDrone(drone)"
              [class.active]="selectedDrone?.id === drone.id"
              [class.disabled]="!canAssignDrone(drone)"
              [style.opacity]="canAssignDrone(drone) ? 1 : 0.6"
              [style.cursor]="canAssignDrone(drone) ? 'pointer' : 'not-allowed'"
              (click)="selectDrone(drone)"
            >
              <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center mb-1">
                    <i class="bi bi-broadcast me-2"></i>
                    <strong>{{ drone.name }}</strong>
                    <!-- N-Number status badge -->
                    <span *ngIf="canAssignDrone(drone)" class="badge bg-success ms-2">
                      <i class="bi bi-check-circle me-1"></i>Registered
                    </span>
                    <span *ngIf="!canAssignDrone(drone)" class="badge bg-warning text-dark ms-2">
                      <i class="bi bi-exclamation-triangle me-1"></i>No N-Number
                    </span>
                  </div>
                  <div class="small">
                    <div>
                      <strong>Serial:</strong> <code [class.text-reset]="selectedDrone?.id === drone.id">{{ drone.serialNumber }}</code>
                      <span *ngIf="drone.nNumber" class="ms-2">
                        <strong>N-Number:</strong> <code [class.text-reset]="selectedDrone?.id === drone.id">{{ drone.nNumber }}</code>
                      </span>
                    </div>
                    <div [class.text-muted]="selectedDrone?.id !== drone.id" [class.opacity-75]="selectedDrone?.id === drone.id">
                      {{ getDroneDisplayName(drone) }}
                    </div>
                    <!-- Warning message for unassignable drones -->
                    <div *ngIf="!canAssignDrone(drone)" class="text-warning mt-1">
                      <i class="bi bi-info-circle me-1"></i>
                      {{ getUnassignableReason(drone) }}
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedDrone?.id === drone.id" class="ms-2">
                  <i class="bi bi-check-circle-fill text-success fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Selected Drone Info -->
        <div *ngIf="selectedDrone" class="alert alert-info">
          <h6 class="alert-heading">
            <i class="bi bi-info-circle me-2"></i>
            Selected Drone
          </h6>
          <p class="mb-0">
            <strong>{{ selectedDrone.name }}</strong> ({{ getDroneDisplayName(selectedDrone) }})
            <br />
            <small>Serial: {{ selectedDrone.serialNumber }}</small>
          </p>
        </div>

        <!-- Assignment Type -->
        <div class="mb-3">
          <label for="assignDroneType" class="form-label">Assignment Type <span class="text-danger">*</span></label>
          <select id="assignDroneType" class="form-select" [(ngModel)]="assignmentType">
            <option [ngValue]="null" disabled>Select a type…</option>
            <option value="leased">Leased</option>
            <option value="demo">Demo</option>
          </select>
          <div class="form-text">A leased drone shows as "Pending Lease" until its lease is set on the drone's page.</div>
        </div>

        <!-- Notes Field -->
        <div class="mb-3">
          <label for="assignmentNotes" class="form-label">Notes (Optional)</label>
          <textarea
            class="form-control"
            id="assignmentNotes"
            rows="3"
            placeholder="Add any notes about this assignment..."
            [(ngModel)]="notes"
            maxlength="500"
          ></textarea>
          <div class="form-text">{{ notes.length }}/500 characters</div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="assignDrone()"
          [disabled]="!selectedDrone || !assignmentType || saving"
        >
          <span *ngIf="!saving">
            <i class="bi bi-check-circle me-2"></i>
            Assign Drone
          </span>
          <span *ngIf="saving">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Assigning...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
